import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Employees from "../../components/OurEmployees";

const EmployeesPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={"Our Employees"} pagesub={"Employees"} />
      <Employees />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default EmployeesPage;
